import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import clanakService from "../../services/clanak.service";
import { Button, Dropdown, Menu, Space, Row, Col } from "antd";
import {
  MenuOutlined,
  TableOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import ClanakCardsKorisnik from "./ClanakCardsKorisnik";
import ClanakList from "./ClanakListKorisnik";
import "../Dokument/DokumentsPageKorisnik.css";
import "./ClanakPage.css";
import SearchBar from "../../components/SearchBar";
import Background from "../../components/Background4";
import kategorijaClankaService from "../../services/kategorijaClanka.service";
export default function ClanakPageKorisnik() {
  const [clanci, setClanci] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const [isListView, setListView] = useState(true);
  const [kategorijaClanka, setKategorijaClanka] = useState(null);
  const [sortCriteria, setSortCriteria] = useState("datumObjave");
  const [sortOrder, setSortOrder] = useState("asc");

  const { kategorijaClankaId } = useParams();

  const fetchClanci = useCallback(async () => {
    try {
      let result;
      if (kategorijaClankaId) {
        let kategorija = await kategorijaClankaService.getById(
          kategorijaClankaId
        );
        setKategorijaClanka(kategorija.data);
        result = await clanakService.getClanciByKategorijaId(
          kategorijaClankaId
        );
      } else {
        result = await clanakService.getAll();
      }

      const aktivniClanci = result.data.filter(
        (clanak) => clanak.aktivan === true
      );
      setClanci(aktivniClanci);
    } catch (error) {}
  }, [kategorijaClankaId]);

    useEffect(() => {
    fetchClanci();
  }, [fetchClanci]);

  const filtriraniClanci = clanci.filter((clanak) =>
    clanak.naslov.toLowerCase().includes(searchTitle.toLowerCase())
  );

  const sortArticles = (articles) => {
    return articles.sort((a, b) => {
      let comparison = 0;
      if (sortCriteria === "datumObjave") {
        comparison = new Date(a.datumObjave) - new Date(b.datumObjave);
      } else if (sortCriteria === "naslov") {
        comparison = a.naslov.localeCompare(b.naslov);
      } else if (sortCriteria === "autor") {
        comparison = a.autor.localeCompare(b.autor);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });
  };

  const sortedClanci = sortArticles([...filtriraniClanci]);

  const sortMenu = (
    <Menu onClick={(e) => setSortCriteria(e.key)}>
      <Menu.Item key="datumObjave">Datum Objave</Menu.Item>
      <Menu.Item key="naslov">Naslov</Menu.Item>
      <Menu.Item key="autor">Autor</Menu.Item>
    </Menu>
  );
 
  return (
    <div>
      <Background />

      <div className="docs-border">
        <div className="docs-container">
          <Row justify="center" align="middle" style={{ width: "90%" }}>
            <Col span={24}>
              <div className="page-title-and-search">
                {kategorijaClanka && (
                  <h1 className="page-title">{kategorijaClanka.naziv}</h1>
                )}
                <SearchBar
                  searchTitle={searchTitle}
                  setSearchTitle={setSearchTitle}
                />
              </div>
            </Col>
          </Row>
          <Row align="middle" style={{ width: "90%" }}>
            <Col className="document-view-right">
              <Space>
                <Button
                  icon={isListView ? <TableOutlined /> : <MenuOutlined />}
                  onClick={() => setListView(!isListView)}
                />
                <Button
                  onClick={() =>
                    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                  }
                >
                  {sortOrder === "asc" ? <UpOutlined /> : <DownOutlined />}
                </Button>
                <Dropdown overlay={sortMenu} trigger={["click"]}> 
                  <Button>
                    Sortiraj
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
          <div className="dokument-list-div">
            {isListView ? (
              <ClanakList clanci={sortedClanci} />
            ) : (
              <ClanakCardsKorisnik clanci={sortedClanci} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
